import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom'
//import { mainStyles, theme } from "../../styles/Main.js"; //Se importan los estilos genéricos
import { Button, Typography, List, Box,useTheme
} from '@mui/material';

import { useStyles } from "./DocumentSignStyles";
import { CustomCounterAppBar, ListElement, CustomLoadingOverlay, GenericContainer ,Buttons } from "../../components";
import { workflowActions, fileActions, addTitleLegoCurrent } from "../../store/actions";
import { coreFunctions } from "../../utils";
import { useTranslation } from 'react-i18next';

export default function DocumentSignComponent(props) {
  const { useState, useEffect } = React;
   const theme = useTheme()
    const location = useLocation()
  const [properties, setProperties] = useState("");
  const [stageName, setStageName] = useState("");
  const [stageSubtitle, setStageSubtitle] = useState("");
  const [currentStage, setCurrentStage] = useState(0);
  const [totalStage, setTotalStage] = useState(0);
  const [signButton, setSignButton] = useState(false)
  const [docTypes, setDocTypes] = useState([]);
  const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 
  const [listDocumentTypes, setListDocumentTypes] = useState("");
  const [activeButtonContinue, setActiveButtonContinue] = useState(false)


  const navigate = useNavigate();
  //Redux hooks
  const auth = useSelector((state) => state.Authentication);
  const fileInfo = useSelector((state) => state.FileInfo);
  const wf = useSelector((state) => state.Workflow);
  const file = useSelector((state) => state.FileInfo);
  const dispatch = useDispatch();

  const localStyles = useStyles();
  const classes = {} //mainStyles.bodyStyles()
  const gridContainer = {} //mainStyles.gridStyle();

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(addTitleLegoCurrent(t("legal_title")))
    // let wfData = {
    //   Workflow_Id: 0,
    //   Workflow_Version: 0,
    //   Apk_Version: "1.0.5",
    //   IMEI: "PWA",
    // };
    // dispatch(workflowActions.GetWorkflowDefinitions(wfData, auth.items.Token));
    console.log("location.state", location.state)
    dispatch(fileActions.GetFileInfo(location.state.folioId));
    setLoadView(true)
  }, []);

  useEffect(() => {
    if (file.items != undefined && loadView) {
      console.log("file.items----------------------------------: ", file.items)
      getStageProperties(file.items);
      setLoadView(false)
    }
  }, [file]);

  let getStageProperties = (element) => {
    // console.log("element: ", element)
    let stageName = element.Stage.Name
    let stageId = element.Stage.Id

    let signatureFindValue = element.Stage?.Properties?.find(item => item.Name == "SignatureType")
    console.log("signatureFindValue:-------------------------- :  ", signatureFindValue)
    if (signatureFindValue?.Value == "FEASAT") {
      setActiveButtonContinue(true)
    } else {
      setActiveButtonContinue(false)
    }

    setCurrentStage(element.Stage.CurrentStageGroup)
    setTotalStage(element.Stage.TotalStageGroups)
    dispatch(addTitleLegoCurrent(element.Stage.Description))
    // setStageName(element.Stage.Description)
    setProperties(element.Stage);
    let listProps = JSON.stringify(element.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes)
    // setListDocumentTypes(listProps)
    let prpSession = sessionStorage.getItem('properties')
    if (prpSession === null) {
      sessionStorage.setItem(
        'properties',
        JSON.stringify(element.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes)
      )
    } else {
      sessionStorage.getItem('properties')
    }


    // console.log("stageName: ", stageName)
    // console.log("stageId: ", stageId)
    // console.log("location.state: ", location.state)
    // console.log("Workflow: ", wf.items)
    // if (wf.items != undefined) {
    //   let items = wf.items;
    //   items.forEach((i) => {
    //     let stages = i.Stages;
    //     let stgPrp = stages.find(
    //       (j) => j.Id === stageId && j.Name === stageName
    //     );
    //     if (stgPrp != undefined && stgPrp != null) {
    //       setTotalStage(stgPrp.TotalStageGroups);
    //       setCurrentStage(stgPrp.CurrentStageGroup);
    //       setStageName(stgPrp.Description)
    //       setProperties(stgPrp);
    //       let prpSession = sessionStorage.getItem('properties')
    //       if (prpSession === null) {
    //         sessionStorage.setItem(
    //           'properties',
    //           JSON.stringify(stgPrp.DocumentalCategory.DocumentalGroups[0].DocumentTypes)
    //         )
    //       } else {
    //         sessionStorage.getItem('properties')
    //       }
    //     }
    //   });
    // }
  };

  useEffect(() => {
    if (properties != "") {
      console.log("properties: ", properties)
      setStageProperties();
    }
  }, [properties]);

  let setStageProperties = () => {
    let prpSession = sessionStorage.getItem('properties')
    let documentTypes1 = (prpSession === null || prpSession?.length < 0 || prpSession?.length == 0) ?
      properties.DocumentalCategory.DocumentalGroups[0].DocumentTypes
      : JSON.parse(prpSession)

    let documentTypes = []
    documentTypes1.forEach(element => {
      if (element.Document != null) {
        documentTypes.push(element)
      }
    })

    let isRejected = props.location.state.isRejected
    let docId = props.location.state.documentId
    let addRejected = documentTypes.find(i => i.Id === docId)

    if (isRejected != undefined) {
      addRejected.isRejected = isRejected
    }

    sessionStorage.setItem(
      'properties',
      JSON.stringify(documentTypes)
    )
    // setListDocumentTypes(JSON.stringify(documentTypes))
    console.log("properties......----setStageProperties----documentTypes--: ", documentTypes)

    console.log("properties......----setStageProperties------: ", properties)
    setDocTypes(documentTypes);
    console.log("documentTypes: list", documentTypes)
    let name = properties.Description;
    dispatch(addTitleLegoCurrent(name))
    // setStageName(name);
    setStageSubtitle(t("select_document_signature"));
    setTotalStage(properties.TotalStageGroups);
    setCurrentStage(properties.CurrentStageGroup);

    evaluateButtonAvailability(documentTypes)
  };

  let evaluateButtonAvailability = (dt) => {
    console.log("evaluateButtonAvailability: list", dt)
    let mustChecked = dt.length
    let actualChecked = 0
    dt.forEach(it => {
      if (it.isRejected != undefined) {
        if (!it.isRejected) {
          actualChecked++
        }
      }
    })
    if (mustChecked === actualChecked) {
      setSignButton(true)
    } else {
      setSignButton(false)
    }
  }
  //Ir a apertura de PDF y firma
  let openSignDocument = (id, oneList = false) => {
    let documentTypes = properties.DocumentalCategory.DocumentalGroups[0].DocumentTypes;
    let dt = documentTypes.find((it) => it.Id === id);

    let docTypes = fileInfo.items.Stage.DocumentalCategory.DocumentalGroups[0].DocumentTypes;
    let specifiedType = docTypes.find((i) => i.Id === dt.Id);

    goToSignDocument(specifiedType, oneList);
  };

  let goToSignDocument = (obj, oneList = false) => {
    let nextStage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = location.state.folioId
    let stage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)
    let documentTypes = obj

    console.log("props  state DocumentViewerCheck", oneList, location.state.stage)

    // let nextComponent = "DocumentViewerCheck"
    let nextComponent = "DocumentViewerCheckCarrusel"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, documentTypes, oneList } })

    // navigate({
    //   pathname: "/DocumentViewerCheck",
    //   state: {
    //     documentTypes: obj,
    //   },
    // });
  };

  let handleSignButton = () => {
    let nextStage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)
    let stageName = nextStage.Name
    let stageId = nextStage.Id
    let folioId = location.state.folioId
    let stage = (location.state.stage.Stage === undefined ? location.state.stage : location.state.stage.Stage)

    let nextComponent = "SignHelp"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })

    // navigate({
    //   pathname: "/SignHelp"
    // });
  }

  let handleContinueButton = () => {
    let folioId = location.state.folioId
    let nextComponent = "FirmaClaveComponent"
    coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId } })
  }

  ////Avanza al siguiente stage de manera automatica:
  useEffect(() => {
    console.log("docTypes*********************: ", docTypes)
    if (docTypes.length == 1) {
      // if (docTypes.length > 0) {
      let varDocCurrent = docTypes[0];
      console.log("docTypes*****varDocCurrent****************: ", varDocCurrent)
      setTimeout(() => {
        console.log("ejecuta timer")
        openSignDocument(varDocCurrent.Id, true)
      }, 500)
    }
  }, [docTypes]);

  return (<GenericContainer>
      <Typography variant="h6">
        {stageName}
      </Typography>
      <Typography variant="subtitle1" >
        {stageSubtitle}
      </Typography>

      <List
        component="nav"
        aria-label="secondary mailbox folders"
        className={localStyles.listView}
      >
        {docTypes.map((i, index) => (
          <Button className={index == 0 ? gridContainer.buttonList1 : gridContainer.buttonList}
            key={`btn_key_${i.Id}`}
            onClick={() => openSignDocument(i.Id)}
          >
            <ListElement
              key={`list_element_key_${i.Id}`}
              keyProps={i.Id}
              text={i.Name}
              isRejected={i.isRejected}
            />
          </Button>
        ))}
      </List>
         
        <Buttons disabledConfirm={activeButtonContinue ?false:true}
          onClickConfirm={handleContinueButton}
        />
       
      {loadView ?
        <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
        : null}
    </GenericContainer>);
}
